import { doc, updateDoc } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";

async function createFavorite(contactId: string, isFavoriteBackoffice: boolean): Promise<void> {
  try {
    const db = firestore;
    const contactRef = doc(db, FirestoreCollections.contacts, contactId);
    await updateDoc(contactRef, { is_favorite_backoffice: isFavoriteBackoffice });
  } catch (e) {
    console.error("Erreur lors de la mise à jour de is_favorite_backoffice:", e);
    throw new CreateFavoriteFailure();
  }
}

export class CreateFavoriteFailure extends Failure {
  constructor(message = "Failed to update is_favorite_backoffice", code = "favorite-update-failure") {
    super(message, code);
  }
}

export default createFavorite;
